var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMenuSettings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 24,
    viewBox: "0 0 22 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.607019 18C1.43418 19.4356 3.26853 19.9288 4.70413 19.1017C4.70511 19.1011 4.70605 19.1005 4.70703 19.1L5.15202 18.843C5.99202 19.5616 6.95755 20.119 8 20.487V21C8 22.6568 9.34316 24 11 24C12.6568 24 14 22.6568 14 21V20.487C15.0426 20.1184 16.0082 19.5604 16.848 18.841L17.295 19.099C18.7309 19.9274 20.5666 19.4349 21.395 17.999C22.2234 16.563 21.731 14.7274 20.295 13.899L19.851 13.643C20.0509 12.5554 20.0509 11.4405 19.851 10.353L20.295 10.097C21.7309 9.26855 22.2234 7.43292 21.395 5.99695C20.5666 4.56103 18.731 4.06852 17.295 4.89694L16.85 5.15395C16.0092 4.43616 15.043 3.87984 14 3.513V3C14 1.34316 12.6568 0 11 0C9.34316 0 8 1.34316 8 3V3.513C6.95741 3.88158 5.99183 4.43958 5.15202 5.15902L4.70502 4.90003C3.26905 4.07156 1.43343 4.56408 0.605003 6C-0.223419 7.43592 0.26905 9.27159 1.70502 10.1L2.14902 10.356C1.94914 11.4435 1.94914 12.5584 2.14902 13.646L1.70502 13.902C0.273035 14.7326 -0.21784 16.5647 0.607019 18ZM11 8.00002C13.2091 8.00002 15 9.79088 15 12C15 14.2091 13.2091 16 11 16C8.79088 16 7.00002 14.2091 7.00002 12C7.00002 9.79088 8.79088 8.00002 11 8.00002Z",
    fill: "#2F4858"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuSettings);
export default __webpack_public_path__ + "static/media/menu_settings.650b31b0d9eeed4f40fe6e44e85044ed.svg";
export { ForwardRef as ReactComponent };